import axiosInstance from '../axiosInterceptor/axiosInstance'

const getStagesWithStandings = async ({ orgId, seasonId }) => {
  const url = `v1/orgs/${orgId}/stages/with-standings?seasonId=${seasonId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getStagesWithStandings
